import { Tooltip, styled } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { AccordionArrow } from '~/views/atoms/svg-icons/accordion-arrow';
import LinearProgress from '@mui/material/LinearProgress';
import { FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useService } from '~/services/service.base';
import { WrapperService } from '~/services/service.wrapper';

export const PurchaseHistory: FC = observer(() => {
    const wrapperService = useService(WrapperService);
    const { accountService, authService } = wrapperService;

    useEffect(() => {
        if (authService.currentUser) {
            accountService.getPurchaseHistory(authService);
        }
    }, [authService.currentUser]);

    const AccordionStyled = styled(Accordion)(() => ({
        borderTop: '1px solid #353945',
    }));

    const AccordionSummaryStyled = styled(AccordionSummary)(() => ({
        padding: 0,
    }));

    const AccordionDetailsStyled = styled(AccordionDetails)(() => ({
        padding: 0,
    }));

    return (
        <div className="account-content ph">
            <div className="account-content-inner">
                <h3>Purchase History</h3>
                <div className="purchase-history-wrap">
                    <div className="ph-desktop">
                        {accountService.transactionsExists && (
                            <div className="ph-table-head">
                                <div className="ph-cell ph-cell-date">Date</div>
                                <div className="ph-cell ph-cell-transaction-id">Transaction ID</div>
                                <div className="ph-cell ph-cell-transaction-type">Transaction Type</div>
                                <div className="ph-cell ph-cell-description">description</div>
                                <div className="ph-cell ph-cell-freeplay">Free Play</div>
                                <div className="ph-cell ph-cell-w">W$</div>
                                <div className="ph-cell ph-cell-amount">amount</div>
                                <div className="ph-cell ph-cell-status">status</div>
                            </div>
                        )}
                        {!accountService.transactionsExists && (
                            <div className="ph-no-transactions">You have not made any purchases yet.</div>
                        )}
                        {accountService.purchaseHistory.map((item, index) => (
                            <div className="ph-table-row" key={index}>
                                <div className="ph-cell ph-cell-date">{item.date}</div>
                                <div className="ph-cell ph-cell-transaction-id">{item.transactionId}</div>
                                <div className="ph-cell ph-cell-transaction-type">{item.transactionType}</div>
                                <div className="ph-cell ph-cell-description">{item.description}</div>
                                <div className="ph-cell ph-cell-freeplay">{item.freeplay}</div>
                                <div className="ph-cell ph-cell-w">{item.dollarPackage}</div>
                                <div className="ph-cell ph-cell-amount">{item.amount}</div>
                                {item.transactionType === 'Redemption' && (
                                    <div className={'ph-cell ph-cell-status ' + item.statusClassName}>
                                        <Tooltip
                                            placement="top"
                                            arrow
                                            title="Your request is being processed, and deposits will be completed within 24 hours."
                                            slotProps={{
                                                popper: {
                                                    modifiers: [
                                                        {
                                                            name: 'offset',
                                                            options: {
                                                                offset: [0, -12],
                                                            },
                                                        },
                                                    ],
                                                },
                                                tooltip: {
                                                    sx: {
                                                        maxWidth: 180,
                                                    },
                                                },
                                            }}
                                        >
                                            <span>{item.status}</span>
                                        </Tooltip>
                                    </div>
                                )}
                                {item.transactionType !== 'Redemption' && (
                                    <div className={'ph-cell ph-cell-status ' + item.statusClassName}>
                                        {item.status}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                    <div
                        className={
                            'ph-mobile' + (!accountService.transactionsExists ? ' ph-mobile-no-transactions' : '')
                        }
                    >
                        {!accountService.transactionsExists && (
                            <div className="ph-no-transactions">You have not made any purchases yet.</div>
                        )}
                        {accountService.purchaseHistory.map((item, index) => (
                            <AccordionStyled key={index}>
                                <AccordionSummaryStyled expandIcon={<AccordionArrow />}>
                                    <div className="phm-head">
                                        <div className="phm-head-date">{item.date}</div>
                                        <div className="phm-head-status">
                                            <span className={item.statusClassName}></span>
                                        </div>
                                    </div>
                                </AccordionSummaryStyled>
                                <AccordionDetailsStyled>
                                    <div className="phm-content">
                                        <div className="phm-content-row">
                                            <div className="phm-content-title">Transaction ID</div>
                                            <div className="phm-content-value">{item.transactionId}</div>
                                        </div>
                                        <div className="phm-content-row">
                                            <div className="phm-content-title">Transaction Type</div>
                                            <div className="phm-content-value">{item.transactionType}</div>
                                        </div>
                                        <div className="phm-content-row">
                                            <div className="phm-content-title">description</div>
                                            <div className="phm-content-value">{item.description}</div>
                                        </div>
                                        <div className="phm-content-row">
                                            <div className="phm-content-title">Free Play</div>
                                            <div className="phm-content-value">{item.freeplay}</div>
                                        </div>
                                        <div className="phm-content-row">
                                            <div className="phm-content-title">W$</div>
                                            <div className="phm-content-value">{item.dollarPackage}</div>
                                        </div>
                                        <div className="phm-content-row">
                                            <div className="phm-content-title">amount</div>
                                            <div className="phm-content-value">{item.amount}</div>
                                        </div>
                                        <div className="phm-content-row">
                                            <div className="phm-content-title">status</div>
                                            {item.transactionType !== 'Redemption' && (
                                                <div className={'phm-content-value ' + item.statusClassName}>
                                                    {item.status}
                                                </div>
                                            )}
                                            {item.transactionType === 'Redemption' && (
                                                <div className={'phm-content-value ' + item.statusClassName}>
                                                    <span>{item.status}</span>
                                                    <span className="phm-awarded-text">
                                                        Awarded every Wednesday at 12PM (EST)
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </AccordionDetailsStyled>
                            </AccordionStyled>
                        ))}
                    </div>
                    {accountService.showLoadingHistory ? <LinearProgress /> : null}
                    {accountService.historyNextCursor && (
                        <div className="load-more-btn-wrap">
                            <button
                                type="button"
                                className="btn"
                                onClick={() => accountService.getPurchaseHistory(authService, true)}
                                disabled={accountService.showLoadingHistory}
                            >
                                Load More
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
});
